export function setIcon(IconsTem, IconN) {
  const iconName = IconN.replace(/-(\w)/g, (_, c) => c.toUpperCase());
  const IconName = iconName.charAt(0).toUpperCase() + iconName.substr(1, iconName.length - 1)
  return IconsTem[iconName] || IconsTem[IconName] || ""
}

export function isInteger(num) {
  return num % 1 === 0
}


export function calNum(num) {
  const BL = 1000
  let decimal = num * BL % BL;

  let isInteger = num * BL - decimal;

  decimal = decimal / BL;
  isInteger = isInteger / BL;
  return { decimal, isInteger }
}


export function rateCom(decimal) {
  decimal = decimal * 100;
  const n = Math.floor(decimal / 10) * 10;

  return n
}



export function getZIndex() {
  const maxZIndexStyle = Array.from(document.querySelectorAll('*'))
    .reduce((prev, current) => {
      const zIndex = parseInt(window.getComputedStyle(current).zIndex);
      return zIndex > prev.zIndex ? { element: current, zIndex: zIndex } : prev;
    }, { element: null, zIndex: -Infinity });
  return maxZIndexStyle.zIndex + 1
}


// export function scrollToDistance(toXDistance, toYDistance) {
//   let disX = toXDistance - Number(document.documentElement && document.documentElement.scrollLeft);
//   let disY = toYDistance - Number(document.documentElement && document.documentElement.scrollTop);

//   animateScrollToTop()

//   function animateScrollToTop() {

//     disX = Math.abs(disX) > 1 ? disX - disX / 8 : 1;
//     disY = Math.abs(disY) > 1 ? disY - disY / 8 : 1;

//     const retX = toXDistance - disX
//     const retY = toYDistance - disY

//     if (Math.abs(disX) > 1 || Math.abs(disY) > 1) {
//       window.requestAnimationFrame(animateScrollToTop);
//       window.scrollTo(retX, retY);
//     }
//   }
// }

// export function scrollToDistance(toXDistance, toYDistance, el) {
//   let disX = toXDistance - Number(document.documentElement && document.documentElement.scrollLeft);
//   let disY = toYDistance - Number(document.documentElement && document.documentElement.scrollTop);

//   if (el) {
//     disX = toXDistance - el.scrollLeft;
//     disY = toYDistance - el.scrollTop;
//   }
//   animateScrollToTop();
//   function animateScrollToTop() {
//     disX = Math.abs(disX) > 1 ? disX - disX / 8 : 1;
//     disY = Math.abs(disY) > 1 ? disY - disY / 8 : 1;

//     const retX = toXDistance - disX;
//     const retY = toYDistance - disY;

//     if (Math.abs(disX) > 1 || Math.abs(disY) > 1) {
//       window.requestAnimationFrame(animateScrollToTop);
//       if (el) {
//         el.scrollTop = retY;
//         el.scrollLeft = retX;
//       } else {
//         window.scrollTo(retX, retY);
//       }
//     }
//   }
// }

export const inBrowser = typeof window !== 'undefined'

export function debounce(fn, d) {
  const delay = d || 200;
  let timer;
  return function () {
    const th = this;
    const args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      timer = null;
      fn.apply(th, args);
    }, delay);
  };
}

export const RegExpStr = (str, searKey, classname) => {
  return str.replace(new RegExp(searKey, "gi"), `<span class="${classname}">${searKey}</span>`);
};











